import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const FooterContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(6, 0),
    marginTop: 'auto',
    borderTop: `1px solid ${theme.palette.divider}`,
}));
